require('./bootstrap');

// jQuery legacy
global.$ = global.jQuery = require('jquery');
try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('popper.js');
    require('bootstrap');
} catch (e) {
 console.log("NO JQUERY");
}

global.logger = require('./logger');

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

import PerfectScrollbar from 'perfect-scrollbar';
window.noUiSlider = require('./plugins/nouislider.min'); // Custom version not available on npm
import anime from 'animejs/lib/anime.es.js';
import './plugins/bootstrap-tagsinput'; // Custom version not available on npm
import './plugins/bootstrap-switch'; // Custom version not available on npm
import './plugins/bootstrap-datetimepicker'; // Custom version not available on npm
// import slick from 'slick-carousel';
import 'slick-carousel';
import initCarousel from './sliders-config'; // Configure all types of sliders
global.initCarousel = initCarousel;

var Chart = require('chart.js');
var moment = require('moment');

// CSRF for jQuery ajax calls
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});



// window.slick = require('slick-carousel');
import 'bootstrap-select';

// window.fileinput = require('jasny-bootstrap');
// Bug with collapsible elements : https://github.com/jasny/bootstrap/issues/537

import './blk-design-system-pro';
// import './Search';
//import './Lesson';
//import './Me';
//import './Home';
//import './Browse';
//import './AccountSettings';
import './partners/WSJ';
import 'cleave.js';

// Cursus
// import './cursus/MainMenu';
// import './cursus/BoxMenu';
// import './cursus/Lesson';

import './cg-navbar';
// import './navMenu';
import './navMenuMobile';
import './Footer';
// import './subnav-underline';
import './blog-banner';

// Third party scripts
// import './external/amplitude';

// Global toaster
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast);
global.toast = Vue.$toast;

if (window.toasts) {
    window.toasts.forEach(function (item){
        toast[item.type](item.message, {
            queue: true
        });
    });
}

var demo = {

  initDocChart: function() {
    chartColor = "#FFFFFF";

    // General configuration for the charts with Line gradientStroke
    gradientChartOptionsConfiguration = {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      tooltips: {
        bodySpacing: 4,
        mode: "nearest",
        intersect: 0,
        position: "nearest",
        xPadding: 10,
        yPadding: 10,
        caretPadding: 10
      },
      responsive: true,
      scales: {
        yAxes: [{
          display: 0,
          gridLines: 0,
          ticks: {
            display: false
          },
          gridLines: {
            zeroLineColor: "transparent",
            drawTicks: false,
            display: false,
            drawBorder: false
          }
        }],
        xAxes: [{
          display: 0,
          gridLines: 0,
          ticks: {
            display: false
          },
          gridLines: {
            zeroLineColor: "transparent",
            drawTicks: false,
            display: false,
            drawBorder: false
          }
        }]
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 15,
          bottom: 15
        }
      }
    };

    ctx = document.getElementById('lineChartExample').getContext("2d");

    gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
    gradientStroke.addColorStop(0, '#80b6f4');
    gradientStroke.addColorStop(1, chartColor);

    gradientFill = ctx.createLinearGradient(0, 170, 0, 50);
    gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
    gradientFill.addColorStop(1, "rgba(249, 99, 59, 0.40)");

    myChart = new Chart(ctx, {
      type: 'line',
      responsive: true,
      data: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        datasets: [{
          label: "Active Users",
          borderColor: "#f96332",
          pointBorderColor: "#FFF",
          pointBackgroundColor: "#f96332",
          pointBorderWidth: 2,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 1,
          pointRadius: 4,
          fill: true,
          backgroundColor: gradientFill,
          borderWidth: 2,
          data: [542, 480, 430, 550, 530, 453, 380, 434, 568, 610, 700, 630]
        }]
      },
      options: gradientChartOptionsConfiguration
    });
  },

  initLandingPageChart: function() {

    var ctx = document.getElementById('chartBig').getContext("2d");

    var gradientFill = ctx.createLinearGradient(0, 350, 0, 50);
    gradientFill.addColorStop(0, "rgba(228, 76, 196, 0.0)");
    gradientFill.addColorStop(1, "rgba(228, 76, 196, 0.14)");

    var chartBig = new Chart(ctx, {
      type: 'line',
      responsive: true,
      data: {
        labels: ["JUN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
        datasets: [{
          label: "Data",
          fill: true,
          backgroundColor: gradientFill,
          borderColor: '#e44cc4',
          borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: '#e44cc4',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: '#be55ed',
          //pointHoverBorderColor:'rgba(35,46,55,1)',
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
          data: [80, 160, 200, 160, 250, 280, 220, 190, 200, 250, 290, 320]
        }]
      },
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },

        tooltips: {
          backgroundColor: '#fff',
          titleFontColor: '#ccc',
          bodyFontColor: '#666',
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        responsive: true,
        scales: {
          yAxes: [{
            barPercentage: 1.6,
            gridLines: {
              drawBorder: false,
              color: 'rgba(0,0,0,0.0)',
              zeroLineColor: "transparent",
            },
            ticks: {
              display: false,
              suggestedMin: 0,
              suggestedMax: 350,
              padding: 20,
              fontColor: "#9a9a9a"
            }
          }],

          xAxes: [{
            barPercentage: 1.6,
            gridLines: {
              drawBorder: false,
              color: 'rgba(0,0,0,0)',
              zeroLineColor: "transparent",
            },
            ticks: {
              padding: 20,
              fontColor: "#9a9a9a"
            }
          }]
        }
      }
    });

  }
}

